/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-02-10 17:55:34
 * @FilePath: /knit-web/src/api/workflow-version.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import {
  SaveWorkflowHistoryRequest,
  PublishWorkflowVersionRequest,
  ListWorkflowHistoryRequest,
  DeprecateWorkflowVersionRequest,
  WorkflowLatestVersionResponse,
  WorkflowVersion,
} from '../types/workflow';

export const saveWorkflowHistoryApi = (data: SaveWorkflowHistoryRequest) => {
  return axios.post<{ action: { type: string }; data: WorkflowVersion }>(
    '/api/console/workflow/v1/history/savehistory',
    data
  );
};

export const publishWorkflowVersionApi = (
  data: PublishWorkflowVersionRequest
) => {
  return axios.post<WorkflowVersion>(
    '/api/console/workflow/v1/history/publishversion',
    data
  );
};

export const listWorkflowHistoryApi = (data: ListWorkflowHistoryRequest) => {
  return axios.post<{ results: WorkflowVersion[]; count: number }>(
    '/api/console/workflow/v1/history/list',
    data
  );
};

export const getWorkflowHistoryInfoApi = (history_uuid: string) => {
  return axios.post<{ history: WorkflowVersion }>(
    '/api/console/workflow/v1/history/info',
    { history_uuid }
  );
};

export const deprecateWorkflowVersionApi = (
  data: DeprecateWorkflowVersionRequest
) => {
  return axios.post<any>('/api/console/workflow/v1/history/deprecate', data);
};

export const updateWorkflowVersionApi = (data: {
  history_uuid: string;
  name: string;
}) => {
  return axios.post<any>('/api/console/workflow/v1/history/update', data);
};

export const getLatestWorkflowVersionApi = (workflow_uuid: string) => {
  return axios.post<WorkflowLatestVersionResponse>(
    '/api/console/workflow/v1/history/getlatestversion',
    { workflow_uuid }
  );
};

export const deleteWorkflowHistoryApi = (history_uuid: string) => {
  return axios.post<any>('/api/console/workflow/v1/history/delete', {
    history_uuid,
  });
};

export default {
  saveWorkflowHistoryApi,
  publishWorkflowVersionApi,
  listWorkflowHistoryApi,
  getWorkflowHistoryInfoApi,
  deprecateWorkflowVersionApi,
  getLatestWorkflowVersionApi,
  updateWorkflowVersionApi,
  deleteWorkflowHistoryApi,
};
